import React from 'react';
import { TitleWrapper } from './styles';

export interface ITitle {
  as?: any;
  hasAltColor?: boolean;
  children: React.ReactNode;
  textAlign?: string;
  uppercase?: boolean;
}

const Title = ({ children, hasAltColor, as = 'h2', textAlign = 'left', uppercase = false }: ITitle) => (
  <TitleWrapper
    as={as}
    hasAltColor={hasAltColor}
    dangerouslySetInnerHTML={{ __html: children }}
    uppercase={uppercase}
    textAlign={textAlign}
  />
);

export default Title;
